import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SignaturePad from '../components/SignaturePad';
import '../styles/HptScreens.css';
import Swal from 'sweetalert2';
import PermisoEscalera from '../components/PermisoEscalera';

// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón reutilizable)
// ============================================================================
const ExpandableCard = ({ title, icon, children }) => {
    const [isOpen, setIsOpen] = useState(false); //Estado para comprobar si está ab|ce
    return (
        <div className="expandable-card">
            <div className="card-header" onClick={() => setIsOpen(!isOpen)}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {/* Si isOpen es true, se añade clase 'open' (display: block) */}
            <div className={`card-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

// ============================================================================
// COMPONENTE PRINCIPAL: CreateHPTScreen
// ============================================================================
const CreateHPTScreen = () => {
    const navigate = useNavigate(); // Redireccion a otras pantallas

    // --- ESTADOS DE DATOS (CATÁLOGOS DEL SERVIDOR) ---
    const [localizaciones, setLocalizaciones] = useState([]); // Localizaciones
    const [usuarios, setUsuarios] = useState([]);             // Listado de Usuarios
    const [catalogo, setCatalogo] = useState([]);             // Catalogos de Riesgos y medidas

    // --- ESTADOS DEL FORMULARIO PRINCIPAL ---
    const [seleccionados, setSeleccionados] = useState([]);   // IDs riesgos marcados. Array
    const [trabajadores, setTrabajadores] = useState([]);     // Array de listado de Trabajadores
    const [materiales, setMateriales] = useState([]);         // Array de materiales
    const [recursos, setRecursos] = useState([]);             // Array de Energías y Trabajos Previos
    const [imagenesBase64, setImagenesBase64] = useState([]); // Fotos subidas, convertidas a texto Base64
    const [archivosPendientes, setArchivosPendientes] = useState([]); // Archivos PDF's, Excel
    const [plantillaActiva, setPlantillaActiva] = useState("vacio"); // Plantillas Predefinidas

    // --- Añadido a Riesgos Maquinaria Medida Otros
    const [detallesRiesgos, setDetallesRiesgos] = useState({});


    // --- ESTADOS DEL BUSCADOR AUTOCOMPLETAR (ACTIVOS) ---
    const [busquedaActivo, setBusquedaActivo] = useState('');     // Texto a Escribir por el usuario
    const [mostrarDesplegable, setMostrarDesplegable] = useState(false); // MUestra resultados en columna
    const [opcionesActivos, setOpcionesActivos] = useState([]);   // Resultados de la búsqueda desde el servidor

    // --- Para autocompletar bloques de usuarios ---
    const [busquedaUsuarios, setBusquedaUsuarios] = useState('');
    const [mostrarDesplegableUsuarios, setMostrarDesplegableUsuarios] = useState(false);
    const [opcionesUsuarios, setOpcionesUsuarios] = useState([]);
    

    // --- Control de botones de guardado
    const [accionSubmit, setAccionSubmit] = useState('sign');
    const [showSignature, setShowSignature] = useState(false);// Mostrar|Ocultar panel de firmas

    // -- Estado de bloqueo de doble Envio
    const [estaGuardando, setSeEstaGuardando] = useState(false);

    // --- Control de Anexos de Escalera ---
    const [showEscaleraModal, setShowEscaleraModal] = useState(false);
    const [datosEscalera, setDatosEscalera] = useState(null);

    // --- Catalogos Eléctricos ---
    const [electricosBloqueo, setElectricosBloqueo] = useState([]);
    const [electricosDescargo, setElectricosDescargo] = useState([]);
    // --- Tablas de Maniobra asignadas a la HPT ---
    const [bloqueosElectricos, setBloqueosElectricos] = useState([]);
    const [descargosElectricos, setDescargosElectricos] = useState([]);
    // --- Asociacion Manual de LOTOS OTRA HPT ---
    const [numManualBloqueo, setNumManualBloqueo] = useState('');
    const [numManualDescargo, setNumManualDescargo] = useState('');
    const [ptwVinculadoBloqueo, setPtwVinculadoBloqueo] = useState('');
    const [ptwVinculadoDescargo, setPtwVinculadoDescargo] = useState('');

    // --- Estado para Plantillas ---
    const [plantillasDisponibles, setPlantillasDisponibles] = useState([]);

    // --- ESTADO CENTRAL DEL FORMULARIO (Campos base) ---
    const [formData, setFormData] = useState({
        titulo: '',
        ot_referencia: '',
        id_activo: '',
        den_act_descripcion: '',
        descripcion_trabajo: '',
        operarios_previstos: '',    
        duracion_prevista_hours: '',
        fecha_prevista: '',
        horario_previsto: '',
        id_localizacion: '',
        interviene_subcontrata: false,
        id_usuario_subcontrata: null,
        preventivos: [],
        tipo_incidencia: 'PREVENTIVO', 
        dias_previstos: '',
        id_st: ''
    });

    // --- CONFIGURACIÓN MAPEADA ---
    // Categorías de recursos y trabajos previos para generar los checkboxes en pantalla
    const CONFIG_RECURSOS = {
        'EQUIPO ESPECIAL': ['Andamiero', 'Calorifugador', 'Soldador', 'ENDs', 'Mecanizado', 'Grup. Electrógeno', 'Compresor', 'Luminarias'],
        'ACCESO': ['Andamio / Andamio taller', 'Plataforma elevadora', 'Anticaídas Retráctiles', 'Línea de vida', 'Banqueta/alfombra', 'Escalera', 'Pescante/tripode'],
        'ENERGÍA TRABAJO': ['Agua', 'N2', 'Argon', 'Aire', 'Electricidad', 'Gasolina/Gasoil'],
        'ENERGÍA EQUIPO': ['HTF', 'Agua', 'Vapor', 'Químicos', 'Nitrógeno', 'Electrica', '75v CC/50v CA'],
        'TRABAJOS PREVIOS': ['Bloqueo eléctrico', 'Descargo eléctrico', 'Descargo mecánico', 'Doble Verificación', 'Despresurizar', 'Drenar', 'PCI Fuera de Servicio', 'Inertizar (N2)', 'INERTIZAR CON VAPOR', 'VENTEO', 'LAVADO DE LÍNEAS', 'SEÑALES FORZADAS DCS', 'EQUIPOS EN TAGOUT', 'DESCARGO LOCs', 'Levantamiento en pruebas']
    };


    // ============================================================================
    //  IDENTIFICACIÓN DEL USUARIO LOGUEADO (Síncrono)
    // ============================================================================
    const token = localStorage.getItem('userToken');
    let currentUser = {};
    let nombreUsuarioCompleto = 'Usuario Desconocido';

    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
            nombreUsuarioCompleto = `${currentUser.nombre || ''} ${currentUser.apellidos || ''}`.trim() || currentUser.user_name || 'Usuario';
        } catch(e) { 
            console.error("Error leyendo token"); 
        }
    }

    // ============================================================================
    //  Efectos al montar Componente.
    // ============================================================================
    useEffect(() => {
        const userRol = currentUser.rol || '';
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const rolAutorizado = ['ADMINISTRADOR', 'PREVENCION', 'CALIDAD', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL'];
        if (userRol && !rolAutorizado.includes(userRol)) {
            Swal.fire("Acceso denegado", "No tienes permiso para estar aquí", "error");
            navigate('/dashboard');
        }
        
        const fetchData = async () => {
            try {
                // Para asegurar velocidad hacemos las tres peticiones a la vez
                const [resLocs, resUsers, resCatalogo, resElectricosBloqueo, resElectricosDescargo, resPlantillas] = await Promise.all([
                    axios.get(`${API_URL}/api/catalogos/localizaciones`, config),
                    axios.get(`${API_URL}/api/catalogos/usuarios`, config),
                    axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosBloqueo`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosDescargo`, config),
                    axios.get(`${API_URL}/api/hpt/plantillas/listar`, config)
                ]);
                
                const extractData = (res) => res.data.results ? res.data.results : res.data;

                setLocalizaciones(extractData(resLocs));
                setUsuarios(extractData(resUsers));
                setCatalogo(extractData(resCatalogo));
                setElectricosBloqueo(extractData(resElectricosBloqueo));
                setElectricosDescargo(extractData(resElectricosDescargo));
                setPlantillasDisponibles(resPlantillas.data || []);
            } catch (err) { console.error("Error cargando catálogos:", err); }
        };
        fetchData();
    }, []);

    // ============================================================================
    // FUNCIONES: APLICAR PLANTILLA DE BASE DE DATOS
    // ============================================================================
    const handleAplicarPlantilla = (e) => {
        const idSeleccionado = e.target.value;

        if (!idSeleccionado || idSeleccionado === "vacio") {
            setSeleccionados([]);
            setRecursos([]);
            setMateriales([]);
            setDetallesRiesgos({});
            setFormData(prev => ({ 
                ...prev, 
                titulo: '',
                tipo_incidencia: 'PREVENTIVO',
                descripcion_trabajo: '',
                duracion_prevista_hours: '',
                operarios_previstos: '',
                horario_previsto: '',
                dias_previstos: '',
                preventivos: []
            }));
            return;
        }

        const plantilla = plantillasDisponibles.find(p => p.id_plantilla === parseInt(idSeleccionado));
        if (!plantilla) return;

        // Parseamos los JSON de forma segura
        const riesgos = JSON.parse(plantilla.json_riesgos || '[]');
        const materialesJson = JSON.parse(plantilla.json_materiales || '[]');
        const recursosJson = JSON.parse(plantilla.json_recursos || '[]');
        const preventivosJson = JSON.parse(plantilla.json_preventivos || '[]');

        setFormData(prev => ({
            ...prev,
            titulo: plantilla.nombre_plantilla || '',
            descripcion_trabajo: plantilla.descripcion_trabajo || '',
            tipo_incidencia: plantilla.tipo_incidencia || 'PREVENTIVO',
            dias_previstos: plantilla.dias_previstos || '',
            operarios_previstos: plantilla.operarios_previstos || '',
            duracion_prevista_hours: plantilla.duracion_prevista_hours || '',
            preventivos: preventivosJson
        }));
        
        setSeleccionados(riesgos.map(r => r.id_item_seguridad));
        
        // Reconstruir detalles de riesgos (inputs de texto manuales)
        const nuevosDetallesRiesgos = {};
        riesgos.forEach(r => {
            if (r.observacion_riesgo) {
                nuevosDetallesRiesgos[r.id_item_seguridad] = r.observacion_riesgo;
            }
        });
        setDetallesRiesgos(nuevosDetallesRiesgos);

        setMateriales(materialesJson);
        setRecursos(recursosJson);
    };

    // ============================================================================
    // FUNCIONES: BUSCADOR DE ACTIVOS (AUTOCOMPLETAR)
    // ============================================================================
    // Se ejecuta al escribir en el campo "codigo activo"
    const buscadorTimeout = useRef(null);
    const buscarActivosEnServidor = async (texto) => {
        setBusquedaActivo(texto);

        if (buscadorTimeout.current) {
            clearTimeout(buscadorTimeout.current);
        }
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 3) {
            setOpcionesActivos([]);
            return;
        }

        // Tiempo de espera para el disparador
        buscadorTimeout.current = setTimeout(async () => {
            try {
                const token = localStorage.getItem('userToken');
                const res = await axios.get(`${API_URL}/api/catalogos/activos/buscar?q=${texto}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // Guardamos los resultados optimizados
                setOpcionesActivos(res.data.results || []);
            } catch (err) {
                console.error("Error buscando activos en el catálogo:", err);
            }
        }, 350);
    };
    const seleccionarActivo = (activo) => {
        setFormData({
            ...formData,
            id_activo: activo.id_activo,
            den_act_descripcion: activo.denominacion
        });
        setBusquedaActivo(activo.codigo_activo);
        setMostrarDesplegable(false);
    }

    // ============================================================================
    // FUNCIONES: BUSCADOR DE USUARIOS (AUTOCOMPLETAR)
    // ============================================================================
    const buscarUsuariosServidor = async (texto) => {
        setBusquedaUsuarios(texto);
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 2) {
            setOpcionesUsuarios([]);
            return;
        }

        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/catalogos/usuarios/buscar?q=${texto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Guarda los resultados en el estado para mostrarlos en la lista desplegable
            setOpcionesUsuarios(res.data.results || []);
        } catch (err) {
            console.error("Error buscando usuarios:", err);
        }
    };

    const seleccionarListaUsuarios = (opcion) => {
        const seleccion = opcion.valor;
        if (!formData.preventivos.includes(seleccion)) {
            setFormData({
                ...formData,
                preventivos: [...formData.preventivos, seleccion]
            });
        }
        
        setBusquedaUsuarios('');
        setMostrarDesplegableUsuarios(false);
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE MATERIALES / REPUESTOS
    // ============================================================================
    // Añade fila vacia en la tabla de materiales
    const addMaterial = () => setMateriales([...materiales, { descripcion: '', unidades: '', almacen: '' }]);

    const updateMaterial = (idx, field, val) => {
        const newM = [...materiales];
        newM[idx][field] = val;
        setMateriales(newM);
    };


    // ============================================================================
    // FUNCIONES: GESTIÓN DE BLOQUEOS ELÉCTRICOS (LOTO)
    // ============================================================================
    const addBloqueoElectrico = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setBloqueosElectricos([...bloqueosElectricos, {
            num_consignacion: numAleatorio,
            id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '',
            textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const removeBloqueoElectrico = (idx) => {
        setBloqueosElectricos(bloqueosElectricos.filter((_, i) => i !== idx));
    };

    const handleFilaBloqueoChange = (idx, texto) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setBloqueosElectricos(nuevasFilas);
    };

    const toggleBloqueoDesplegable = (idx, visible) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx].mostrarDesplegable = visible && nuevasFilas[idx].textoBusqueda.length >= 2;
        setBloqueosElectricos(nuevasFilas);
    };

    const seleccionarElementoBloqueoElectrico = (idx, elemento) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo, // Dejamos el Tag visible en el input
            mostrarDesplegable: false // Cerramos su desplegable
        };
        setBloqueosElectricos(nuevasFilas);
    };

    const addBloqueoManual = () => {
        if (!numManualBloqueo) return;
        setBloqueosElectricos([...bloqueosElectricos, {
            num_consignacion: parseInt(numManualBloqueo),
            id_item: '', activo: 'MANUAL', centro_cargas: '-', ubicacion: '-', tension: 0,
            descripcion: ptwVinculadoBloqueo ? `LOTO vinculado al PTW: ${ptwVinculadoBloqueo}` : 'Consignación manual',
            textoBusqueda: ptwVinculadoBloqueo ? `[MANUAL] Nº ${numManualBloqueo} (PTW: ${ptwVinculadoBloqueo})` : `[MANUAL] Nº ${numManualBloqueo}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoBloqueo || null
        }]);
        setNumManualBloqueo('');
        setPtwVinculadoBloqueo('');
    };



    // ============================================================================
    // FUNCIONES: GESTIÓN DE BLOQUEOS ELÉCTRICOS (LOTO)
    // ============================================================================
    const addDescargoElectrico = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setDescargosElectricos([...descargosElectricos, {
            num_consignacion: numAleatorio,
            id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '',
            textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const removeDescargoElectrico = (idx) => {
        setDescargosElectricos(descargosElectricos.filter((_, i) => i !== idx));
    };

    const handleFilaDescargoChange = (idx, texto) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setDescargosElectricos(nuevasFilas);
    };

    const toggleDescargoDesplegable = (idx, visible) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx].mostrarDesplegable = visible && nuevasFilas[idx].textoBusqueda.length >= 2;
        setDescargosElectricos(nuevasFilas);
    };

    const seleccionarElementoDescargoElectrico = (idx, elemento) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo,
            mostrarDesplegable: false
        };
        setDescargosElectricos(nuevasFilas);
    };

    const addDescargoManual = () => {
        if (!numManualDescargo) return;
        setDescargosElectricos([...descargosElectricos, {
            num_consignacion: parseInt(numManualDescargo),
            id_item: '', activo: 'MANUAL', centro_cargas: '-', ubicacion: '-', tension: 0,
            descripcion: ptwVinculadoDescargo ? `LOTO vinculado al PTW: ${ptwVinculadoDescargo}` : 'Consignación manual',
            textoBusqueda: ptwVinculadoDescargo ? `[MANUAL] Nº ${numManualDescargo} (PTW: ${ptwVinculadoDescargo})` : `[MANUAL] Nº ${numManualDescargo}`,
            mostrarDesplegable: false,
            ptw_vinculado: ptwVinculadoDescargo || null 
        }]);
        setNumManualDescargo('');
        setPtwVinculadoDescargo('');
    };


    // ============================================================================
    // FUNCIONES: GESTIÓN DE RECURSOS Y TRABAJOS PREVIOS
    // ============================================================================
    // Se ejecuta al marcar/desmarcar un checkbo
    const handleRecursoToggle = (cat, nombre, checked) => {
        // Busca si el recurso ya existía en el array
        const exists = recursos.find(r => r.categoria === cat && r.nombre_recurso === nombre);
        
        if (exists) {
            // Si ya existe, simplemente actualiza su estado (true/false)
            setRecursos(recursos.map(r => (r.categoria === cat && r.nombre_recurso === nombre) ? { ...r, valor_check: checked } : r));
        } else {
            // Si no existe, lo añade al array de recursos a guardar
            setRecursos([...recursos, { categoria: cat, nombre_recurso: nombre, valor_check: checked, detalle_texto: "" }]);
        }
    };

    const handleRecursoText = (cat, nombre, texto) => {
        setRecursos(recursos.map(r => 
            (r.categoria === cat && r.nombre_recurso === nombre) 
                ? { ...r, detalle_texto: texto } 
                : r
        ));
    };


    // ============================================================================
    // FUNCIONES: GESTIÓN DE TRABAJADORES (SUBCONTRATA)
    // ============================================================================
    // Añade una tarjeta de trabajador vacía con todas las habilidades en false
    const addTrabajador = () => {
        setTrabajadores([...trabajadores, {
            nombre: '', apellidos: '', empresa: '',
            carretilla_elevadora: false, carretilla_telescopica: false,
            plataforma_elevadora: false, puente_grua: false,
            espacios_confinados: false, baja_tension: false,
            alta_tension: false, recurso_preventivo: false,
            camion_pluma: false, grua: false,
            formacion_altura: false, otros: ''
        }]);
    };

    // Actualiza el dato de un trabajador específico (texto o checkbox)
    const updateTrabajador = (idx, field, val) => {
        const newT = [...trabajadores];
        newT[idx][field] = val;
        setTrabajadores(newT);
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE FOTOS (Reducción de tamaño)
    // ============================================================================
    // Coge la foto de la cámara/galería y la reduce a 800px para no saturar el servidor
    const comprimirImagen = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Convierte a Base64
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 800;
                    const scaleSize = MAX_WIDTH / img.width;
                    canvas.width = MAX_WIDTH;
                    canvas.height = img.height * scaleSize;

                    // Dibuja la imagen en un lienzo invisible más pequeño
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    
                    // Extrae la imagen comprimida con calidad al 60%
                    const base64Reducido = canvas.toDataURL('image/jpeg', 0.6);
                    resolve(base64Reducido);
                };
            };
        });
    };

    const eliminarImagen = (indexToRemove) => {
        setImagenesBase64(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // ============================================================================
    // GUARDADO Con FIRMA
    // ============================================================================
    // Se ejecuta tras realizar la firma.
    const handleSaveWithSignature = async (signatureBase64) => {

        // Control de doble click
        if (estaGuardando) return;
        setSeEstaGuardando(true);

        const token = localStorage.getItem('userToken');
        
        try {
            const anexoFormateado = datosEscalera ? {
                ...datosEscalera,
                clasificacion: Array.isArray(datosEscalera.clasificacion) ? datosEscalera.clasificacion.join(', ') : (datosEscalera.clasificacion || ''),
                justificacion: Array.isArray(datosEscalera.justificacion) ? datosEscalera.justificacion.join(', ') : (datosEscalera.justificacion || '')
            } : null;
            // LIpiamos y hacemos tratamientos de datos de INT y Strings
            const payload = {
                ...formData,
                titulo: formData.titulo || "Sin título",
                id_st: formData.id_st || '',
                id_activo: formData.id_activo ? parseInt(formData.id_activo) : null,
                id_localizacion: formData.id_localizacion ? parseInt(formData.id_localizacion) : null,
                operarios_previstos: formData.operarios_previstos ? parseInt(formData.operarios_previstos) : null,
                duracion_prevista_hours: formData.duracion_prevista_hours ? parseInt(formData.duracion_prevista_hours) : null,
                dias_previstos: formData.dias_previstos ? parseInt(formData.dias_previstos) : 1,
                // Si la subcontrata no aplica, pasamos usuario a NULL.
                id_usuario_subcontrata: formData.interviene_subcontrata && formData.id_usuario_subcontrata 
                    ? parseInt(formData.id_usuario_subcontrata) 
                    : null,
                
                // Aseguramos que los IDS sean numeros.
                riesgos_seleccionados: seleccionados.map(id => ({
                    id_item_seguridad: parseInt(id),
                    observacion_riesgo: detallesRiesgos[id] || ""
                })),
                
                materiales, 
                recursos, 
                trabajadores, 
                imagenes: imagenesBase64,
                anexo_escalera: anexoFormateado,
                bloqueos_electricos: bloqueosElectricos.filter(b => b.activo !== ''),
                descargos_electricos: descargosElectricos.filter(d => d.activo !== '')
            };

            // Enviamos JSON para crear la HPT. Pasa a estdo creada
            const resHpt = await axios.post(`${API_URL}/api/hpt`, payload, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            if (archivosPendientes.length > 0) {
                for (const file of archivosPendientes) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/hpt/${resHpt.data.id_hpt}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }

            // Tras crearla, obtenemos el id y mandamos la firma
            await axios.post(`${API_URL}/api/hpt/${resHpt.data.id_hpt}/firmar`, {
                firma_path: signatureBase64,
                es_sustituto: false
            }, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            // Si todo va correctamente volvemos a Dashboard
            navigate('/dashboard');

        } catch (err) { 
            // Restauramos el estado anterior, por si existe fallo en petición no nos quede bloqueado.
            setSeEstaGuardando(false);
            // Capturamos errores de ZOD del BackEnd
            console.error("❌ Error al crear HPT:", err.response?.data || err);
            
            const detalleError = err.response?.data?.detail;
            if (detalleError) {
                Swal.fire({
                    title: "Error de Validación",
                    text: `Error de validación en el formulario:\n${JSON.stringify(detalleError)}`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            } else {
                Swal.fire({
                    title: "Error al crear la HPT.",
                    text: "Revisa consola para ver más detalles.",
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            }
        }
    };

    // ============================================================================
    // GUARDADO SIN FIRMA
    // ============================================================================
    const handleSaveWithoutSignature = async () => {

        // Control de doble click
        if (estaGuardando) return;
        setSeEstaGuardando(true);

        const token = localStorage.getItem('userToken');
        
        try {
            const anexoFormateado = datosEscalera ? {
                ...datosEscalera,
                clasificacion: Array.isArray(datosEscalera.clasificacion) ? datosEscalera.clasificacion.join(', ') : (datosEscalera.clasificacion || ''),
                justificacion: Array.isArray(datosEscalera.justificacion) ? datosEscalera.justificacion.join(', ') : (datosEscalera.justificacion || ''),
                medioAutorizacion: datosEscalera.medioAutorizacion || ""
            } : null;
            const payload = {
                ...formData,
                titulo: formData.titulo || "Sin título",
                id_st: formData.id_st || '',
                id_activo: formData.id_activo ? parseInt(formData.id_activo) : null,
                id_localizacion: formData.id_localizacion ? parseInt(formData.id_localizacion) : null,
                operarios_previstos: formData.operarios_previstos ? parseInt(formData.operarios_previstos) : null,
                duracion_prevista_hours: formData.duracion_prevista_hours ? parseInt(formData.duracion_prevista_hours) : null,
                dias_previstos: formData.dias_previstos ? parseInt(formData.dias_previstos) : 1,
                id_usuario_subcontrata: formData.interviene_subcontrata && formData.id_usuario_subcontrata 
                    ? parseInt(formData.id_usuario_subcontrata) 
                    : null,
                // Aseguramos que los IDS sean numeros.
                riesgos_seleccionados: seleccionados.map(id => ({
                    id_item_seguridad: parseInt(id),
                    observacion_riesgo: detallesRiesgos[id] || ""
                })), 
                materiales, 
                recursos, 
                trabajadores, 
                imagenes: imagenesBase64,
                anexo_escalera: anexoFormateado,
                bloqueos_electricos: bloqueosElectricos.filter(b => b.activo !== ''),
                descargos_electricos: descargosElectricos.filter(d => d.activo !== '')
            };

            // Enviamos JSON para crear la HPT (Pasa a estado CREADA y pendiente de SOLICITANTE)
            const resHpt = await axios.post(`${API_URL}/api/hpt`, payload, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            // Subida de archivos asociados a esta HPT
            if (archivosPendientes.length > 0) {
                for (const file of archivosPendientes) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/hpt/${resHpt.data.id_hpt}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }
            
            // Volvemos al Dashboard
            navigate('/dashboard');

        } catch (err) { 
            // Restauramos el estado anterior, por si existe fallo en petición no nos quede bloqueado.
            setSeEstaGuardando(false);
            console.error("❌ Error al guardar HPT sin firma:", err.response?.data || err);
            const detalleError = err.response?.data?.detail;
            if (detalleError) {
                Swal.fire({
                    title: "Error de Validación",
                    text: `Error de validación en el formulario:\n${JSON.stringify(detalleError)}`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            } else {
                Swal.fire({
                    title: "Fallo",
                    text: `Error al guardar la HPT:  ${err}.`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            }
        }
    };

    // Extrae categorias Unidas
    const categoriasSeguridad = [...new Set(catalogo.map(item => item.categoria))];

    
    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            <form onSubmit={(e) => { 
                e.preventDefault(); 
                if (accionSubmit === 'sign') {
                    setShowSignature(true); // Abre el lienzo de firmas
                } else {
                    handleSaveWithoutSignature(); // Guarda directo
                }
            }}>
                
                {/* --- CABECERA --- */}
                <div className="top-header">
                    <div className="d-flex align-center">
                        <span className="ptw-label">NUEVA HPT:</span>
                        <div className="ptw-badge">
                            <span style={{ fontSize: '20px' }}>📋</span> 
                            OT: {formData.ot_referencia || 'SIN ASIGNAR'}
                        </div>
                    </div>
                    <div className="header-actions">
                        <button type="submit" className="btn-save" onClick={() => setAccionSubmit('sign')}>
                            ✍️ Proceder a Firma
                        </button>
                        <button type="submit" className="btn-save" style={{ backgroundColor: '#1a237e' }} onClick={() => setAccionSubmit('save')}>
                            💾 Guardar sin Firma
                        </button>
                        <button type="button" onClick={() => navigate('/dashboard')} className="btn-close">Cancelar</button>
                    </div>
                </div>

                {/* --- DATOS GENERALES --- */}
                <div className="main-card">
                    <div className="card-header-internal">Información Base de Planificación</div>

                    {/* --- DESPLEGABLE DE PLANTILLAS DINÁMICAS --- */}
                    <div className="template-banner">
                        <span className="template-title">CARGAR PLANTILLA PREDEFINIDA:</span>
                        <select className="main-select" onChange={handleAplicarPlantilla}>
                            <option value="vacio">-- Crear desde cero (Opcional) --</option>
                            {plantillasDisponibles.map(p => (
                                <option key={p.id_plantilla} value={p.id_plantilla}>
                                    {p.nombre_plantilla}
                                </option>
                            ))}
                        </select>
                        <span className="template-note">
                            * Al elegir una plantilla se indicarán los datos base y se marcarán automáticamente los riesgos, recursos y materiales.
                        </span>
                    </div>

                    <div className="row">
                        <div className="info-box flex-2">
                            <span className="info-label">TÍTULO</span>
                            <input 
                                type="text" 
                                required 
                                className="main-input" 
                                value={formData.titulo}
                                onChange={e => setFormData({...formData, titulo: e.target.value})} 
                            />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">NÚMERO DE OT:</span>
                            <input type="text" required className="main-input" onChange={e => setFormData({...formData, ot_referencia: e.target.value})} />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">ID ST:</span>
                            <input type="text" className="main-input" value={formData.id_st} onChange={e => setFormData({...formData, id_st: e.target.value})}/>
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">ZONA DE TRABAJO:</span>
                            <select required className="main-select" onChange={e => setFormData({...formData, id_localizacion: e.target.value})}>
                                <option value="">-- Seleccione Zona --</option>
                                {localizaciones.map(loc => <option key={loc.id_localizacion} value={loc.id_localizacion}>{loc.nombre_zona}</option>)}
                            </select>
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">Tipo de Incidencia:</span>
                            <select 
                                required className="main-select" 
                                value={formData.tipo_incidencia} 
                                onChange={e => setFormData({...formData, tipo_incidencia: e.target.value})}
                            >
                                <option value="PREVENTIVO">PREVENTIVO</option>
                                <option value="CORRECTIVO">CORRECTIVO</option>
                                <option value="MODIFICACION">MODIFICACIÓN</option>
                            </select>
                        </div>
                    </div>

                    {/* SECCIÓN DEL BUSCADOR DE ACTIVOS (AUTOCOMPLETAR) */}
                    <div className="asset-section-hpt">
                        <div className="row">
                            <div className="info-box flex-1 relative"> 
                                <span className="info-label">CÓDIGO ACTIVO (Buscador):</span>
                                
                                <input 
                                    type="text" 
                                    className="main-input" 
                                    placeholder="Escriba código o nombre..."
                                    value={busquedaActivo}
                                    onChange={(e) => {
                                        const valor = e.target.value;
                                        buscarActivosEnServidor(valor);
                                        setMostrarDesplegable(valor.length >= 3);
                                        if (formData.id_activo) {
                                            setFormData({...formData, id_activo: '', den_act_descripcion: ''});
                                        }
                                    }}
                                    onFocus={() => setMostrarDesplegable(true)}
                                    onBlur={() => setTimeout(() => setMostrarDesplegable(false), 200)}
                                />

                                {/* Lista flotante de resultados del buscador */}
                                {mostrarDesplegable && busquedaActivo.length >= 2 && (
                                    <ul className="autocomplete-list">
                                        {opcionesActivos.length > 0 ? (
                                            opcionesActivos.map(a => (
                                                <li 
                                                    key={a.id_activo} 
                                                    className="autocomplete-item"
                                                    onMouseDown={() => seleccionarActivo(a)} 
                                                >
                                                    <strong>{a.codigo_activo}</strong> <br/>
                                                    <span className="text-small text-muted">{a.denominacion}</span>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="autocomplete-item">No se encontraron activos...</li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            
                            <div className="info-box flex-2 asset-display-box">
                                <span className="info-label">DENOMINACIÓN DEL EQUIPO:</span>
                                <div className="asset-name-text">
                                    {formData.den_act_descripcion || 'Seleccione un activo en el buscador...'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="info-grid">
                        <div className="info-box">
                            <span className="info-label">👥 OPERARIOS:</span>
                            <input type="number" min="1" required className="main-input" value={formData.operarios_previstos} onChange={e => setFormData({...formData, operarios_previstos: parseInt(e.target.value)})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">📅 FECHA:</span>
                            <input type="date" required className="main-input" value={formData.fecha_prevista} onChange={e => setFormData({...formData, fecha_prevista: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">🕒 HORARIO:</span>
                            <input type="text" placeholder="Ej: 08:00 - 16:00" required className="main-input" value={formData.horario_previsto} onChange={e => setFormData({...formData, horario_previsto: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">⏳ HORAS PREVISTAS:</span>
                            <input type="number" min="1" required className="main-input" value={formData.duracion_prevista_hours} onChange={e => setFormData({...formData, duracion_prevista_hours: parseInt(e.target.value)})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">📅 DURACIÓN DÍAS:</span>
                            <input type="text" placeholder="Ej: 1" required className="main-input" value={formData.dias_previstos} onChange={e => setFormData({...formData, dias_previstos: e.target.value})} />
                        </div>
                    </div>

                    <div className="description-container">
                        <span className="info-label">DESCRIPCIÓN DE LAS TAREAS:</span>
                        <textarea rows="3" required className="main-textarea" value={formData.descripcion_trabajo} onChange={e => setFormData({...formData, descripcion_trabajo: e.target.value})} />
                    </div>

                   {/* Recuso Preventivo */}
                    <div className="asset-section-hpt">
                        <div className="row">
                            <div className="info-box flex-1 relative"> 
                                <span className="info-label">🛡️ ASIGNAR RECURSO PREVENTIVO (Usuario o Grupo):</span>
                                
                                <input 
                                    type="text" 
                                    className="main-input" 
                                    placeholder="Escriba el nombre, apellidos, rol o grupo..."
                                    value={busquedaUsuarios}
                                    onChange={(e) => {
                                        buscarUsuariosServidor(e.target.value);
                                        setMostrarDesplegableUsuarios(true);
                                    }}
                                    onFocus={() => setMostrarDesplegableUsuarios(true)}
                                    onBlur={() => setTimeout(() => setMostrarDesplegableUsuarios(false), 200)}
                                />

                                {/* Lista flotante de resultados del buscador */}
                                {mostrarDesplegableUsuarios && busquedaUsuarios.length >= 2 && (
                                    <ul className="autocomplete-list">
                                        {opcionesUsuarios.length > 0 ? (
                                            opcionesUsuarios.map((op, index) => (
                                                <li 
                                                    key={`${op.valor}-${index}`}
                                                    className="autocomplete-item"
                                                    onMouseDown={() => seleccionarListaUsuarios(op)}
                                                >
                                                    <strong>{op.tipo === 'GRUPO' ? '👥 Grupo:' : '👤 Usuario:'} {op.etiqueta}</strong>
                                                    <br/>
                                                    <span className="text-small text-muted" style={{ wordBreak: 'break-all' }}>
                                                        {op.descripcion}
                                                    </span>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="autocomplete-item">No se encontraron resultados...</li>
                                        )}
                                    </ul>
                                )}

                                {/* Mostrar los que ya hemos seleccionado como "chips" */}
                                <div className="selected-tags mt-10">
                                    {formData.preventivos.map((prev, index) => (
                                        <span key={index} className="skill-tag skill-preventive" style={{display: 'inline-block', margin: '5px'}}>
                                            {prev} 
                                            <button 
                                                type="button" 
                                                onClick={() => setFormData({...formData, preventivos: formData.preventivos.filter((_, i) => i !== index)})}
                                                style={{marginLeft: '8px', background: 'none', border: 'none', cursor: 'pointer', color: '#d32f2f', fontWeight: 'bold'}}
                                            >
                                                ✖
                                            </button>
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* SECCIÓN DE FOTOGRAFÍAS */}
                    <div className="mt-20">
                        <h3 className="section-title">📸 Fotografías de la HPT</h3>

                        <input type="file" accept="image/*" multiple onChange={async (e) => {
                                const archivos = Array.from(e.target.files);
                                // Comprime todas las fotos seleccionadas a la vez
                                const base64Array = await Promise.all(archivos.map(file => comprimirImagen(file)));
                                setImagenesBase64(prev => [...prev, ...base64Array]);
                            }} 
                        />

                        <div className="photo-preview-container">
                        {imagenesBase64.map((imgBase64, index) => (
                            <div key={index} className="relative">
                                <img 
                                    src={imgBase64} 
                                    alt="preview" 
                                    className="img-preview-edit"
                                />
                                {/* Botón rojo de borrar superpuesto a la imagen */}
                                <button 
                                    type="button"
                                    onClick={() => eliminarImagen(index)}
                                    className="btn-delete-img"
                                >
                                    X
                                </button>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>

                {/* SECCIÓN DE DOCUMENTOS ADJUNTOS */}
                <div className="document-section">
                    <h3 className="section-title">
                        📎 Documentos Adjuntos (PDF, Excel, Word)
                    </h3>
                    <div className="document-upload-zone mt-10">
                        <input
                            type="file"
                            accept=".pdf,.xls,.xlsx,.doc,.docx"
                            multiple
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                setArchivosPendientes(prev => [...prev, ...files]);
                            }}
                        />
                    </div>

                    {archivosPendientes.length > 0 && (
                        <div className="document-list">
                            {archivosPendientes.map((file, index) => (
                                <div key={index} className="document-item document-item-pending">
                                    <div className="document-info">
                                        <span className="document-icon">⏳</span>
                                        <span>{file.name} <em className="text-pending-status">({(file.size / 1024 / 1024).toFixed(2)} MB)</em></span>
                                    </div>
                                    <button type="button" onClick={() => setArchivosPendientes(prev => prev.filter((_, i) => i !== index))} className="btn-delete-file">
                                        X Quitar
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* --- BLOQUES ACOORDEONES --- */}
                
                {/* MATERIALES */}
                <ExpandableCard title="Repuestos y Herramientas" icon="🔧">
                    <table className="table">
                        <thead>
                            <tr className="table-header">
                                <th className="th">Descripción</th>
                                <th className="th">UD</th>
                                <th className="th">Almacén</th>
                                <th className="th">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {materiales.map((m, idx) => (
                                <tr key={idx}>
                                    <td className="td"><input className="borderless-input" value={m.descripcion} onChange={e => updateMaterial(idx, 'descripcion', e.target.value)} /></td>
                                    <td className="td"><input className="borderless-input" value={m.unidades} onChange={e => updateMaterial(idx, 'unidades', e.target.value)} /></td>
                                    <td className="td"><input className="borderless-input" value={m.almacen} onChange={e => updateMaterial(idx, 'almacen', e.target.value)} /></td>
                                    <td className="td text-center" onClick={() => setMateriales(materiales.filter((_,i) => i !== idx))}>❌</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" onClick={addMaterial} className="add-btn">+ Añadir Fila</button>
                </ExpandableCard>

                {/* RECURSOS Y ENERGÍAS */}
                <ExpandableCard title="Recursos, Energías y Trabajos Previos" icon="⚡">
                    {/* Itera sobre el objeto CONFIG_RECURSOS creando una sección por cada categoría */}
                    {Object.entries(CONFIG_RECURSOS).map(([categoria, items]) => (
                        <div key={categoria} className="mb-20">
                            <div className="res-cat-title">{categoria}</div>
                            <div className="grid-checks">
                                {items.map(item => {
                                    // Buscamos el recurso completo para saber si está checkeado y si tiene texto guardado
                                    const recursoEncontrado = recursos.find(r => r.categoria === categoria && r.nombre_recurso === item);
                                    const isChecked = recursoEncontrado ? recursoEncontrado.valor_check : false;
                                    const textoDetalle = recursoEncontrado ? recursoEncontrado.detalle_texto : '';
                                    
                                    return (
                                        <div key={item} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                            <label className={`hab-item ${isChecked ? 'checked' : ''}`}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={isChecked}
                                                    onChange={(e) => handleRecursoToggle(categoria, item, e.target.checked)} 
                                                />
                                                {item}
                                            </label>

                                            {/* Si es 'Químicos' y está marcado, mostramos la caja de texto */}
                                            {item === 'Químicos' && isChecked && (
                                                <input 
                                                    type="text" 
                                                    className="main-input res-text-input" 
                                                    placeholder="Especifique qué químico..." 
                                                    value={textoDetalle}
                                                    onChange={(e) => handleRecursoText(categoria, item, e.target.value)}
                                                    required
                                                />
                                            )}

                                            {/* Si es 'Escalera' y está marcado, mostramos el botón flotante */}
                                            {item === 'Escalera' && isChecked && (
                                                <div style={{ marginTop: '5px', marginLeft: '25px' }}>
                                                    <button 
                                                        type="button" 
                                                        className="btn-save" 
                                                        style={{ 
                                                            backgroundColor: datosEscalera ? '#2e7d32' : '#f57c00', // Verde si está relleno, Naranja si falta
                                                            padding: '6px 12px', fontSize: '12px' 
                                                        }}
                                                        onClick={() => setShowEscaleraModal(true)}
                                                    >
                                                        📄 {datosEscalera ? 'Anexo Escalera (Completado)' : 'Rellenar Anexo Escalera'}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                    {/* DETECTOR DE ENCLAVAMIENTO ELÉCTRICO */}
                    {recursos.some(r => r.categoria === 'TRABAJOS PREVIOS' && r.nombre_recurso === 'Bloqueo eléctrico' && r.valor_check) && (
                        <div className="loto-wrapper">
                            <div className="loto-title-panel">⚡ Bloqueo Eléctrico</div>
                            
                            <table className="table">
                                <thead>
                                    <tr className="table-header">
                                        <th className="th" style={{ width: '30%' }}>Tag Activo (Buscador Predictivo)</th>
                                        <th className="th" style={{ width: '20%' }}>Centro de Cargas</th>
                                        <th className="th" style={{ width: '30%' }}>Panel / Celda / Maniobra</th>
                                        <th className="th" style={{ width: '10%' }}>Tensión</th>
                                        <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bloqueosElectricos.map((bloqueo, idx) => (
                                        <tr key={idx}>
                                            {/* Buscador de Tags Eléctricos con coincidencia múltiple */}
                                            <td className="td relative">
                                                <input 
                                                    type="text" 
                                                    className="main-input w-100 loto-yellow-input"
                                                    placeholder="Teclee Tag Eléctrico (Ej: 00-V...)"
                                                    value={bloqueo.textoBusqueda}
                                                    onChange={(e) => handleFilaBloqueoChange(idx, e.target.value)}
                                                    onFocus={() => toggleBloqueoDesplegable(idx, true)}
                                                    // Retardo en el blur para dejar que el onMouseDown del click procese antes de ocultar
                                                    onBlur={() => setTimeout(() => toggleBloqueoDesplegable(idx, false), 200)}
                                                />

                                                {/* Desplegable Predictivo sobre el estado local 'electricos' */}
                                                {bloqueo.mostrarDesplegable && (
                                                    <ul className="autocomplete-list loto-dropdown">
                                                        {electricosBloqueo.filter(e => 
                                                            e.activo.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()) ||
                                                            (e.descripcion && e.descripcion.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()))
                                                        ).length > 0 ? (
                                                            electricosBloqueo
                                                                .filter(e => 
                                                                    e.activo.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()) ||
                                                                    (e.descripcion && e.descripcion.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()))
                                                                )
                                                                .map(elem => (
                                                                    <li 
                                                                        key={elem.id_item} 
                                                                        className="autocomplete-item loto-dropdown-item"
                                                                        onMouseDown={() => seleccionarElementoBloqueoElectrico(idx, elem)}
                                                                    >
                                                                        <strong>{elem.activo}</strong> — <span className="loto-cc-tag">{elem.centro_cargas}</span>
                                                                        <div className="loto-muted-text">{elem.ubicacion} {elem.descripcion ? `(${elem.descripcion})` : ''} — <strong>{elem.tension}V</strong></div>
                                                                    </li>
                                                                ))
                                                        ) : (
                                                            <li className="autocomplete-item text-pending-status">No se encontraron elementos en el catálogo...</li>
                                                        )}
                                                    </ul>
                                                )}
                                            </td>

                                            {/* Campos automáticos en modo lectura */}
                                            <td className="td loto-readonly">{bloqueo.centro_cargas}</td>
                                            <td className="td loto-readonly">
                                                <div>{bloqueo.ubicacion}</div>
                                                {bloqueo.descripcion && <small className="text-muted-small">{bloqueo.descripcion}</small>}
                                            </td>
                                            <td className="td loto-readonly text-center font-bold">
                                                {bloqueo.tension ? `${bloqueo.tension} V` : ''}
                                            </td>

                                            {/* Botón de Borrado de fila */}
                                            <td className="td text-center">
                                                <button type="button" className="del-btn" onClick={() => removeBloqueoElectrico(idx)}>Quitar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                                <button type="button" className="add-btn" style={{ marginTop: 0 }} onClick={addBloqueoElectrico}>
                                    + Añadir Bloqueo (Buscador)
                                </button>
                                <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                    <input type="number" className="main-input" placeholder="Nº Bloqueo" value={numManualBloqueo} onChange={(e) => setNumManualBloqueo(e.target.value)} style={{ width: '100px' }} />
                                    <input type="text" className="main-input" placeholder="PTW (Opcional)" value={ptwVinculadoBloqueo} onChange={(e) => setPtwVinculadoBloqueo(e.target.value)} style={{ width: '130px' }} />
                                    <button type="button" className="btn-save" style={{ padding: '6px 12px' }} onClick={addBloqueoManual}>Vincular</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* DETECTOR DE ENCLAVAMIENTO ELÉCTRICO */}
                    {recursos.some(r => r.categoria === 'TRABAJOS PREVIOS' && r.nombre_recurso === 'Descargo eléctrico' && r.valor_check) && (
                        <div className="loto-wrapper">
                            <div className="loto-title-panel">⚡ Descargo Eléctrico</div>
                            
                            <table className="table">
                                <thead>
                                    <tr className="table-header">
                                        <th className="th" style={{ width: '30%' }}>Tag Activo (Buscador Predictivo)</th>
                                        <th className="th" style={{ width: '20%' }}>Centro de Cargas</th>
                                        <th className="th" style={{ width: '30%' }}>Panel / Celda / Maniobra</th>
                                        <th className="th" style={{ width: '10%' }}>Tensión</th>
                                        <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {descargosElectricos.map((descargo, idx) => (
                                        <tr key={idx}>
                                            {/* Buscador de Tags Eléctricos con coincidencia múltiple */}
                                            <td className="td relative">
                                                <input 
                                                    type="text" 
                                                    className="main-input w-100 loto-yellow-input"
                                                    placeholder="Teclee Tag Eléctrico (Ej: 00-V...)"
                                                    value={descargo.textoBusqueda}
                                                    onChange={(e) => handleFilaDescargoChange(idx, e.target.value)}
                                                    onFocus={() => toggleDescargoDesplegable(idx, true)}
                                                    // Retardo en el blur para dejar que el onMouseDown del click procese antes de ocultar
                                                    onBlur={() => setTimeout(() => toggleDescargoDesplegable(idx, false), 200)}
                                                />

                                                {/* Desplegable Predictivo sobre el estado local 'electricos' */}
                                                {descargo.mostrarDesplegable && (
                                                    <ul className="autocomplete-list loto-dropdown">
                                                        {electricosDescargo.filter(e => 
                                                            e.activo.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()) ||
                                                            (e.descripcion && e.descripcion.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()))
                                                        ).length > 0 ? (
                                                            electricosDescargo
                                                                .filter(e => 
                                                                    e.activo.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()) ||
                                                                    (e.descripcion && e.descripcion.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()))
                                                                )
                                                                .map(elem => (
                                                                    <li 
                                                                        key={elem.id_item} 
                                                                        className="autocomplete-item loto-dropdown-item"
                                                                        onMouseDown={() => seleccionarElementoDescargoElectrico(idx, elem)}
                                                                    >
                                                                        <strong>{elem.activo}</strong> — <span className="loto-cc-tag">{elem.centro_cargas}</span>
                                                                        <div className="loto-muted-text">{elem.ubicacion} {elem.descripcion ? `(${elem.descripcion})` : ''} — <strong>{elem.tension}V</strong></div>
                                                                    </li>
                                                                ))
                                                        ) : (
                                                            <li className="autocomplete-item text-pending-status">No se encontraron elementos en el catálogo...</li>
                                                        )}
                                                    </ul>
                                                )}
                                            </td>

                                            {/* Campos automáticos en modo lectura */}
                                            <td className="td loto-readonly">{descargo.centro_cargas}</td>
                                            <td className="td loto-readonly">
                                                <div>{descargo.ubicacion}</div>
                                                {descargo.descripcion && <small className="text-muted-small">{descargo.descripcion}</small>}
                                            </td>
                                            <td className="td loto-readonly text-center font-bold">
                                                {descargo.tension ? `${descargo.tension} V` : ''}
                                            </td>

                                            {/* Botón de Borrado de fila */}
                                            <td className="td text-center">
                                                <button type="button" className="del-btn" onClick={() => removeDescargoElectrico(idx)}>Quitar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                                <button type="button" className="add-btn" style={{ backgroundColor: '#2e7d32', marginTop: 0 }} onClick={addDescargoElectrico}>
                                    + Añadir Descargo (Buscador)
                                </button>
                                <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                    <input type="number" className="main-input" placeholder="Nº Descargo" value={numManualDescargo} onChange={(e) => setNumManualDescargo(e.target.value)} style={{ width: '100px' }} />
                                    <input type="text" className="main-input" placeholder="PTW (Opcional)" value={ptwVinculadoDescargo} onChange={(e) => setPtwVinculadoDescargo(e.target.value)} style={{ width: '130px' }} />
                                    <button type="button" className="btn-save" style={{ padding: '6px 12px' }} onClick={addDescargoManual}>Vincular</button>
                                </div>
                            </div>
                        </div>
                    )}
                </ExpandableCard>
                
                {/* MATRIZ DE RIESGOS */}
                <ExpandableCard title="Matriz de Riesgos y Medidas" icon="🚨">
                    {categoriasSeguridad.map(cat => (
                        <div key={cat} className="mb-20">
                            <div className="res-cat-title">{cat}</div>
                            <div className="grid-checks">
                                {/* Filtra el catálogo para pintar solo los ítems de esta categoría */}
                                {catalogo.filter(i => i.categoria === cat).map(item => {
                                    const isSelected = seleccionados.includes(item.id_item);
                                    
                                    // Asignamos la clase correcta dependiendo de si es rojo (Riesgo) o verde (Medida Correctiva)
                                    let badgeClass = 'risk-badge';
                                    if (isSelected) {
                                        badgeClass += item.es_riesgo ? ' checked-risk' : ' checked-measure';
                                    }
                                    
                                    const esComodinMaquinaria = item.codigo === '10007';

                                    return (
                                        <div key={item.id_item}>
                                            <label className={badgeClass}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={isSelected} 
                                                    onChange={() => {
                                                        if (isSelected) {
                                                            setSeleccionados(seleccionados.filter(i => i !== item.id_item));
                                                            const nuevosDetalles = { ...detallesRiesgos };
                                                            delete nuevosDetalles[item.id_item];
                                                            setDetallesRiesgos(nuevosDetalles);
                                                        } else {
                                                            setSeleccionados([...seleccionados, item.id_item]);
                                                        }
                                                    }} 
                                                />
                                                <span className={`text-small ${item.es_riesgo ? 'text-risk' : 'text-measure'}`}>
                                                    <strong>{item.codigo}</strong> - {item.descripcion}
                                                </span>
                                            </label>
                                            {isSelected && esComodinMaquinaria && (
                                                <input 
                                                    type="text" 
                                                    className="main-input res-text-input" 
                                                    placeholder="Especifique máquina: ej. Tractor" 
                                                    value={detallesRiesgos[item.id_item] || ''}
                                                    onChange={(e) => setDetallesRiesgos({
                                                        ...detallesRiesgos,
                                                        [item.id_item]: e.target.value
                                                    })}
                                                    required 
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </ExpandableCard>
                
                {/* ASIGNACIÓN DE EMPRESA SUBCONTRATADA */}
                <div className="subcontractor-box">
                    <label className="d-flex align-center gap-10" style={{ fontWeight: 'bold' }}>
                        <input type="checkbox" checked={formData.interviene_subcontrata} onChange={(e) => setFormData({...formData, interviene_subcontrata: e.target.checked})} /> 
                        ¿INTERVIENE EMPRESA SUBCONTRATADA?
                    </label>
                    {formData.interviene_subcontrata && (
                        <select required className="main-select w-100 mt-10" onChange={(e) => setFormData({...formData, id_usuario_subcontrata: parseInt(e.target.value)})}>
                            <option value="">-- Asignar Responsable --</option>
                            {usuarios.map(u => <option key={u.id_usuario} value={u.id_usuario}>{u.nombre} {u.apellidos}</option>)}
                        </select>
                    )}
                </div>

                {/* TRABAJADORES SUBCONTRATA */}
                {formData.interviene_subcontrata && (
                    <ExpandableCard title="Trabajadores de Subcontrata" icon="👷">
                        <div className="worker-grid">
                            {trabajadores.map((t, idx) => (
                                <div key={idx} className="worker-card">
                                    <div className="worker-header">
                                        <strong>TRABAJADOR #{idx + 1}</strong>
                                        <button type="button" onClick={() => setTrabajadores(trabajadores.filter((_, i) => i !== idx))} className="del-btn">Eliminar</button>
                                    </div>
                                    <div className="row">
                                        <input className="main-input flex-1" placeholder="Nombre" value={t.nombre} onChange={e => updateTrabajador(idx, 'nombre', e.target.value)} />
                                        <input className="main-input flex-1" placeholder="Apellidos" value={t.apellidos} onChange={e => updateTrabajador(idx, 'apellidos', e.target.value)} />
                                    </div>
                                    <div className="row">
                                        <input className="main-input w-100" placeholder="Empresa Subcontrata..." value={t.empresa || ''} onChange={e => updateTrabajador(idx, 'empresa', e.target.value)} />
                                    </div>
                                    {/* Listado de Habilitaciones del trabajador */}
                                    <div className="hab-grid-full">
                                        {[
                                            {id: 'carretilla_elevadora', label: 'Carretilla Elev.'},
                                            {id: 'carretilla_telescopica', label: 'C. Telescópica'},
                                            {id: 'plataforma_elevadora', label: 'Pla. Elevadora'},
                                            {id: 'puente_grua', label: 'Puente Grúa'},
                                            {id: 'espacios_confinados', label: 'Esp. Confinados'},
                                            {id: 'formacion_altura', label: 'F. Altura'},
                                            {id: 'baja_tension', label: 'Baja Tensión'},
                                            {id: 'alta_tension', label: 'Alta Tensión'},
                                            {id: 'camion_pluma', label: 'Camión Pluma'},
                                            {id: 'grua', label: 'Grúa'},
                                            {id: 'recurso_preventivo', label: 'RECURSO PREVENTIVO', special: true}
                                        ].map(hab => (
                                            <label key={hab.id} className={`hab-item ${hab.special ? 'special' : ''}`}>
                                                <input type="checkbox" checked={t[hab.id]} onChange={e => updateTrabajador(idx, hab.id, e.target.checked)} />
                                                {hab.label}
                                            </label>
                                        ))}
                                        <input className="main-input span-2" placeholder="Otros certificados..." value={t.otros} onChange={e => updateTrabajador(idx, 'otros', e.target.value)} />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button type="button" onClick={addTrabajador} className="add-btn">+ Añadir Trabajador</button>
                    </ExpandableCard>
                )}

                

            </form>
            
            {/* --- COMPONENTE FLOTANTE: PAD DE FIRMA --- */}
            {showSignature && <SignaturePad onSave={handleSaveWithSignature} onCancel={() => setShowSignature(false)} />}
            {/* --- COMPONENTE FLOTANTE: ANEXO ESCALERA --- */}
            {showEscaleraModal && (
                <PermisoEscalera 
                    datosPrevios={datosEscalera} 
                    usuarioActual={currentUser.user}
                    onSave={(data) => {
                        setDatosEscalera(data);
                        setShowEscaleraModal(false);
                    }} 
                    onCancel={() => setShowEscaleraModal(false)} 
                />
            )}
        </div>
    );
};

export default CreateHPTScreen;